import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { SettingItem } from './SettingItem'

interface DisableGalleryUploadSwitchProps {
  number: number
}

export const DisableGalleryUploadSwitch: React.FC<DisableGalleryUploadSwitchProps> = ({ number }) => {
  const { control } = useFormContext()

  const t_disableGalleryUpload = useLocaleText('disable_gallery_upload') || 'Disable gallery upload'

  return (
    <SettingItem
      number={number}
      title={t_disableGalleryUpload}
      control={
        <Controller
          as={ControlledCustomSwitch}
          name="disable_gallery_upload"
          control={control}
          valueName="isChecked"
          size="lg"
          onChange={([event]) => {
            return event.target.checked
          }}
        />
      }
    />
  )
}
